import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["topBackgroundColor", "bottomBackgroundColor", "oneCardHorizontalLayout", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as a } from "react/jsx-runtime";
import t from "react";
import { colors as n } from "@silversea-ssc/design-system-tokens";
import { c as C } from "../clsx-OuTLNxxd.js";
import { SectionContainer as w } from "../SectionContainer/SectionContainer.js";
const f = "FareInfographicsMosaic-module_container__bQwuT",
  u = "FareInfographicsMosaic-module_mosaic__HgOM-",
  g = "FareInfographicsMosaic-module_with-1-card__gx042",
  M = "FareInfographicsMosaic-module_with-1-card-horizontal__Zn6RM",
  F = "FareInfographicsMosaic-module_with-2-cards__FQd-y",
  b = "FareInfographicsMosaic-module_with-more-cards__jhs7Y",
  o = {
    container: f,
    mosaic: u,
    with1Card: g,
    with1CardHorizontal: M,
    with2Cards: F,
    withMoreCards: b
  },
  z = _ref => {
    let {
        topBackgroundColor: e,
        bottomBackgroundColor: d,
        oneCardHorizontalLayout: i = !1,
        children: c
      } = _ref,
      l = _objectWithoutProperties(_ref, _excluded);
    const h = n[e],
      m = n[d],
      _ = {
        "--top-background-color": h,
        "--bottom-background-color": m
      },
      r = t.Children.count(c),
      p = t.Children.map(c, s => {
        if (t.isValidElement(s)) return /* @__PURE__ */a("div", {
          children: t.cloneElement(s)
        });
      });
    return /* @__PURE__ */a("div", {
      className: o.container,
      "data-content-name": "fares_mosaic",
      style: _,
      children: /* @__PURE__ */a(w, _objectSpread(_objectSpread({}, l), {}, {
        backgroundColor: "transparent",
        children: /* @__PURE__ */a("div", {
          className: C(o.mosaic, {
            [o.with1Card]: !i && r == 1,
            [o.with1CardHorizontal]: i && r == 1,
            [o.with2Cards]: r == 2,
            [o.withMoreCards]: r > 2
          }),
          children: p
        })
      }))
    });
  };
export { z as FareInfographicsMosaic };